import React from "react";
import PropTypes from "prop-types";
import InputOptions from "./InputOptions";

const InputSelect = ({ modClass, placeholder, value, options, onChange }) => (
  <div className="form-group">
    <select
      className={modClass ? "form-control " + modClass : "form-control"}
      value={value || placeholder}
      onChange={onChange}
    >
      <option key="default" disabled>
        {placeholder}
      </option>
      <InputOptions options={options} />
    </select>
  </div>
);

InputSelect.propTypes = {
  modClass: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InputSelect;
